export default __webpack_public_path__ + "static/media/Philadelphia_brunch_25_pdf_recipe_cards_UK.cc105df3.pdf";